import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import { BiData } from '@wix/da-bi/pkg/events';
import PointsCard from '@wix/da-shared-react/pkg/PointsCard';
import { getPointsPackages } from '../../../redux/form/selectors';
import PointsFooter from './PointsFooter';
import s from './PointsModal.scss';
const PointsModal = (props)=>{
    const { t } = useTranslation('dreamup');
    const isMobile = useContext(MobileContext);
    const pointsPackages = useSelector(getPointsPackages);
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            component: 'points'
        }
    }, /*#__PURE__*/ React.createElement(Modal, _object_spread({
        isOpen: true,
        heading: isMobile ? t('dreamup.modal.points.heading.mobile') : t('dreamup.modal.points.heading'),
        footer: /*#__PURE__*/ React.createElement(PointsFooter, null)
    }, props), /*#__PURE__*/ React.createElement("div", {
        className: s['content-root']
    }, pointsPackages.map((pointsPackage, index)=>/*#__PURE__*/ React.createElement(PointsCard, {
            key: index,
            pointsAmount: pointsPackage.points,
            price: pointsPackage.price,
            subproductId: pointsPackage.subproductId,
            biData: BiData({
                evid: 919,
                points_total: pointsPackage.points,
                subproductid: pointsPackage.subproductId
            })
        })))));
};
PointsModal.displayName = 'PointsModal';
export default PointsModal;

//# sourceMappingURL=PointsModal.js.map